import styled from '@emotion/styled'
import {
  BorderOutlined,
  UnorderedListOutlined,
  ClusterOutlined,
} from '@ant-design/icons'
import { useFormikContext } from 'formik'
import { STRUCTURE_TYPE_OPTIONS } from '@sportninja/common/features/competition/wizard'
import type { WizardFormValues } from '@sportninja/common/features/competition/wizard'
import ChoiceCard from '../components/ChoiceCard'
import { competitionWord } from '@sportninja/common/features/competition/wizard'
import Text from 'src/components/ts-components/Text'
import colors from '@sportninja/common/constants/appColors'

const STRUCTURE_ICONS = {
  single: <BorderOutlined style={{ fontSize: 40 }} />,
  multiple: <UnorderedListOutlined style={{ fontSize: 40 }} />,
  conferences: <ClusterOutlined style={{ fontSize: 40 }} />,
} as const

const Step4Structure = () => {
  const { values, setFieldValue } = useFormikContext<WizardFormValues>()

  const handleSelect = (next: WizardFormValues['structureType']) => {
    if (values.structureType === next) {
      return
    }
    setFieldValue('structureType', next)
    setFieldValue('divisions', [])
    setFieldValue('conferences', [])
  }

  return (
    <Container>
      <Header>
        <Text variant='heading3' weight='semiBold' color={colors.WHITE}>
          How Is Your {competitionWord()} Structured?
        </Text>
        <Text variant='paragraphMedium' color={colors.NEUTRAL_50}>
          Choose how teams will be organized.
        </Text>
      </Header>
      <Grid>
        {STRUCTURE_TYPE_OPTIONS.map((opt) => (
          <ChoiceCard
            key={opt.value}
            icon={STRUCTURE_ICONS[opt.value]}
            title={opt.label}
            description={opt.description}
            selected={values.structureType === opt.value}
            onClick={() => handleSelect(opt.value)}
            testId={`choice-structure-${opt.value}`}
          />
        ))}
      </Grid>
    </Container>
  )
}

export default Step4Structure

// ---- styled ----
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  width: 100%;
`

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  text-align: center;
`

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  width: 100%;
  max-width: 720px;

  & > button {
    height: 275px;
  }

  /* Force card titles onto two lines so all three cards align */
  & > button > p:first-of-type {
    max-width: 10ch;
    margin-left: auto;
    margin-right: auto;
  }
`
